<template>
  <div>
    <ModalImage v-if="modalFlag" @closeModalImage="closeModalImage"  :url="urlSelect"/>
    <Nav/>
    <section class="gallery_wrapper">
      <div class="gallery_list">
        <transition-group name="fade" mode="in-out" >
          <div class="image" v-for="image in imagesList" :key="image.url" @click="selectImage(image.url)">
            <img :src="image.url" alt="">
          </div>
        </transition-group >
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import ModalImage from '@/components/ModalImage'
import Footer from '@/components/Footer'
import { firestore } from '@/main'

export default {
  components: {
    Nav,
    Footer,
    ModalImage
  },
  data: () => ({
    imagesList: [],
    modalFlag: false,
    urlSelect: ""
  }),
  mounted () {
    this.getAllimages()
  },
  methods: {
    selectImage (url) {
      if (window.innerWidth > 400) {
        this.urlSelect = url
        this.modalFlag = true
      }
    } ,
    closeModalImage () {
      this.modalFlag = false
    },
    getAllimages() {
      firestore
        .collection('images')
        .orderBy('initial', 'desc')
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            const data = doc.data()
            this.imagesList.push({
              id: doc.id,
              url: data.url,
            })
          })
        })
        .catch(console.error)
    }
  }
}
</script>

<style lang="sass" scoped>
.gallery_wrapper
  min-height: calc(100vh - 470px)
  padding: 50px 0
  .gallery_list
    span
      margin: 0 auto
      width: 980px
      display: grid
      grid-template-columns: repeat(auto-fit,minmax(250px ,1fr))
      grid-template-rows: repeat(auto-fit, 200px)
      grid-gap: 20px
      grid-auto-flow: row dense
      padding: 0 70px
      box-sizing: border-box
      .image
        cursor: pointer
        &:first-child, &:nth-child(17n)
          grid-column: span 2
          grid-row: span 2
        &:nth-child(7n)
          grid-column: span 3
        img
          width: 100%
          height: 100%
          min-height: 200px
          object-fit: cover
nav
  animation: none
  height: 70px

@media screen and (max-width: 980px)
  .gallery_wrapper
    .gallery_list
      span
        margin: 0 auto
        width: 100%

@media screen and (max-width: 760px)
  .gallery_wrapper
    padding: 20px 0
    .gallery_list
      span
        padding: 0 20px

@media screen and (max-width: 560px)
  .gallery_wrapper
    .gallery_list
      span
        grid-template-columns: 1fr 1fr
        .image
          &:first-child, &:nth-child(17)
            grid-column: inherit
            grid-row: inherit
          &:nth-child(7)
            grid-column: inherit
  nav
    animation: none
    height: 55px
    .nav_wrapper
      justify-content: flex-end
      .logo
        display: none
      ul
        justify-content: flex-end
        width: 100%
        height: 55px
        li
          color: white
          .Button
            height: 55px


@media screen and (max-width: 400px)
  .gallery_wrapper
    .gallery_list
      span
        grid-template-columns: 1fr
</style>